import { useSearchParams } from "react-router-dom";
import type { PublicPackagesSearchCriteria } from "./PublicPackagesSearch";

const SEARCH_PARAMS_KEY = "tags";

export const usePublicPackagesSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tagsParam = searchParams.get(SEARCH_PARAMS_KEY) ?? "";
  const tags = tagsParam
    .split(",")
    .filter((t) => t.length > 0 && t.includes("::"))
    .map((t) => t.split("::"))
    .map(([category, value]) => ({ category, value }));

  const setSearchCriteria = ({ tags }: PublicPackagesSearchCriteria) =>
    setSearchParams((prev) => {
      const value = tags?.map(({ category, value }) => `${category}::${value}`).join(",") ?? "";
      if (value) {
        prev.set(SEARCH_PARAMS_KEY, value);
      } else {
        prev.delete(SEARCH_PARAMS_KEY);
      }
      return prev;
    });

  return {
    searchCriteria: {
      tags,
    },
    setSearchCriteria,
  };
};
